__turbopack_context__.v({
  "card-container": "browse-course-carousel-module-scss-module__sJ4dsG__card-container",
  "margin-top-xs": "browse-course-carousel-module-scss-module__sJ4dsG__margin-top-xs",
});
